import Feature from 'Services/Feature';
import OldReportsListing from 'vcomponents/pages/reports/ReportsListing.vue';
import Dashboard from 'vcomponents/pages/reports/cumulio/Dashboard.vue';
import ReportsListing from 'vcomponents/reports/listing/ReportsListing.vue';
import ReportsDashboard from 'vcomponents/reports/dashboard/ReportsDashboard.vue';

const checkAccess = (to, from, next) => {
    if (!Feature.isEnabled('reports-2025')) {
        return next({ name: 'error.not.found' });
    }
    next();
};

export default [
    // OLD ROUTE
    {
        path: '/reports/all',
        name: 'reports.old.listing',
        component: OldReportsListing,
    },
    {
        path: '/reports/cumulio/:id',
        name: 'reports.cumulio',
        component: Dashboard,
        props: true,
    },

    // NEW ROUTE (reports-2025)
    {
        path: '/reports/listing',
        name: 'reports.listing',
        component: ReportsListing,
        beforeEnter: checkAccess,
    },
    {
        path: '/reports/dashboard/:id',
        name: 'reports.dashboard',
        component: ReportsDashboard,
    },
];
